import ReactGA from 'react-ga';

let currentPage = '';

const googleAnalytics = () => next => action => {
  if (action.type === '@@router5/TRANSITION_SUCCESS') {
    const nextPage = action.payload.route.path;

    if (currentPage !== nextPage) {
      currentPage = nextPage;
      ReactGA.pageview(nextPage);
    }
  }

  return next(action);
};

export default googleAnalytics;



// WEBPACK FOOTER //
// ./src/reactGAMiddleware.js